import SCMCreateFolderModal from "./SCMCreateFolderModal";

export default SCMCreateFolderModal;
